var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenant-confirm-block" }, [
    _c("p", { staticClass: "tenant-confirm" }, [
      _vm._v(
        _vm._s(_vm.$t("tenantConfirms." + _vm.regionName + ".topOfPage_p1"))
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "tenant-confirm" }, [
      _vm._v(
        _vm._s(_vm.$t("tenantConfirms." + _vm.regionName + ".topOfPage_p2"))
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "tenant-confirm" }, [
      _vm._v(
        _vm._s(_vm.$t("tenantConfirms." + _vm.regionName + ".topOfPage_p3"))
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }